<template>
  <div class="h-screen sm:bg-gray-050">
    <Navbar/>
    <div class="flex max-w-7xl mx-auto">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "@vue/composition-api";
import Navbar from "../../components/dashboard/Navbar";

export default defineComponent({
  name: "master",
  components: {
    Navbar,
  },
  beforeCreate() {
    this.$store.dispatch("job/getJobs");
    this.$store.dispatch("studio/getStudios");
    this.$store.dispatch("users/getUsers");
  },
  
});
</script>

<style>
</style>